import PropTypes from "prop-types";
import MediaGallery from "components/MediaGallery";
import MKTypography from "components/MKTypography";

const Medias = ({ media }) => {
  if (!media || media.length === 0) return null;
  return (
    <>
      <MKTypography variant="h5" mt={2} mb={1}>
        Médias
      </MKTypography>
      <MediaGallery media={media} showTitle={false} />
    </>
  );
};

Medias.propTypes = {
  media: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      label: PropTypes.string,
    })
  ).isRequired,
};

export default Medias;
